import apiSlice from "./ApiSlice";

const advancePaymentApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // get all delivery dates
        getAllAdvancePaymentData: builder.query({
            providesTags: ["advance-payment"],
            query: (body: PaginationPayloadType) => {
                return {
                    url: "/advance-payment",
                    method: "POST",
                    body,
                };
            },
        }),

        // delete delivery date
        deleteAdvancePaymentById: builder.mutation({
            invalidatesTags: ["advance-payment"],
            query: (id: any) => ({
                url: `/advance-payment/${id}`,
                method: "DELETE",
            }),
        }),
        // add delivery date
        addAdvancePayment: builder.mutation({
            invalidatesTags: ["advance-payment"],
            query: (body) => ({
                url: `/advance-payment/add`,
                method: "POST",
                body,
            }),
        }),
        //get delivery date by Id
        getAdvancePaymentById: builder.query({
            providesTags: ["advance-payment"],
            query: (id: string) => {
                return {
                    url: `/advance-payment/${id}`,
                    method: "GET",
                };
            },
        }),

        // update delivery date
        updateAdvancePaymentById: builder.mutation({
            invalidatesTags: ["advance-payment"],
            query: ({ body, id }) => ({
                url: `/advance-payment/${id}`,
                method: "PUT",
                body,
            }),
        }),
        cencelAdvancePaymentById: builder.mutation({
            invalidatesTags: ["advance-payment"],
            query: ({ body, id }) => ({
                url: `/advance-payment/cancel/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // change status of delivery date
        changeStatusAdvancePaymentById: builder.mutation({
            invalidatesTags: ["advance-payment"],
            query: ({ body, id }) => ({
                url: `/advance-payment/status-change/${id}`,
                method: "PUT",
                body,
            }),
        }),
    }),
});

export const {
    useGetAllAdvancePaymentDataQuery,
    useDeleteAdvancePaymentByIdMutation,
    useAddAdvancePaymentMutation,
    useGetAdvancePaymentByIdQuery,
    useUpdateAdvancePaymentByIdMutation,
    useChangeStatusAdvancePaymentByIdMutation,
    useCencelAdvancePaymentByIdMutation
} = advancePaymentApi;
